module.exports = __webpack_public_path__ + "img/Group 14.c794d724.svg";